{
  "language": {
    "label": "Langue",
    "description": "Langue de l'interface. Les nouveaux espaces de travail héritent de cette langue pour leurs rapports générés.",
    "english": "English",
    "french": "Français",
    "chinese": "中文"
  },
  "settings": {
    "title": "Paramètres",
    "appearance": "Apparence",
    "darkMode": "Mode sombre",
    "darkModeOnDescription": "Thème sombre activé",
    "darkModeOffDescription": "Thème clair activé",
    "dangerZone": "Zone sensible",
    "clearAll": "Tout supprimer",
    "clearAllDescription": "Supprimer définitivement tous les projets, fichiers, rapports, journaux et modèles",
    "purge": "Supprimer"
  },
  "modelSet": {
    "title": "Ensemble de modèles",
    "label": "Ensemble de modèles",
    "choose": "Choisir",
    "loading": "Chargement des ensembles de modèles…",
    "noneAvailable": "Aucun ensemble de modèles n'est disponible pour le moment.",
    "appliesAll": "Ce choix s'applique à l'ensemble du déploiement et à tous les espaces de travail. Un changement prend effet au prochain appel de modèle ; les travaux déjà en cours ne sont pas modifiés.",
    "errorTimeout": "La requête a pris trop de temps. Veuillez réessayer.",
    "errorNetwork": "Impossible de joindre le serveur. Vérifiez votre connexion et réessayez.",
    "errorGeneric": "Une erreur s'est produite. Veuillez réessayer."
  },
  "workspace": {
    "createTitle": "Créer un espace de travail",
    "outputLanguage": "Langue du rapport",
    "outputLanguageHint": "Les rapports générés pour cet espace de travail seront rédigés dans cette langue. Ce choix ne peut pas être modifié après la création.",
    "outputLanguageLockedHint": "La langue du rapport est verrouillée après la création.",
    "create": "Créer",
    "cancel": "Annuler"
  },
  "actions": {
    "ok": "OK",
    "cancel": "Annuler",
    "save": "Enregistrer",
    "delete": "Supprimer",
    "edit": "Modifier",
    "close": "Fermer",
    "confirm": "Confirmer",
    "submit": "Envoyer",
    "next": "Suivant",
    "previous": "Précédent",
    "back": "Retour",
    "continue": "Continuer",
    "retry": "Réessayer",
    "refresh": "Actualiser",
    "copy": "Copier",
    "copied": "Copié",
    "download": "Télécharger",
    "upload": "Importer",
    "remove": "Retirer",
    "add": "Ajouter",
    "rename": "Renommer",
    "search": "Rechercher",
    "filter": "Filtrer",
    "clear": "Effacer",
    "loading": "Chargement...",
    "approve": "Approuver",
    "reject": "Rejeter",
    "open": "Ouvrir",
    "view": "Afficher",
    "more": "Plus",
    "less": "Moins",
    "yes": "Oui",
    "no": "Non"
  },
  "status": {
    "loading": "Chargement...",
    "saving": "Enregistrement...",
    "saved": "Enregistré",
    "ready": "Prêt",
    "error": "Erreur",
    "pending": "En attente",
    "complete": "Terminé",
    "failed": "Échec",
    "draft": "Brouillon",
    "approved": "Approuvé",
    "rejected": "Rejeté"
  },
  "time": {
    "justNow": "à l'instant",
    "minutesAgo_one": "il y a {{count}} minute",
    "minutesAgo_other": "il y a {{count}} minutes",
    "hoursAgo_one": "il y a {{count}} heure",
    "hoursAgo_other": "il y a {{count}} heures",
    "daysAgo_one": "il y a {{count}} jour",
    "daysAgo_other": "il y a {{count}} jours"
  },
  "dialog": {
    "confirmDeleteTitle": "Confirmer la suppression",
    "unsavedChangesTitle": "Modifications non enregistrées",
    "unsavedChangesBody": "Vous avez des modifications non enregistrées. Les abandonner ?",
    "discard": "Abandonner"
  },
  "empty": {
    "noResults": "Aucun résultat.",
    "noData": "Aucune donnée disponible."
  },
  "image": {
    "loading": "Chargement de l'image...",
    "imageNotFound": "Image introuvable",
    "loadFailed": "Échec du chargement de l'image",
    "missingArtifactRef": "Référence d'artefact manquante",
    "imageUnavailable": "Image indisponible",
    "artifactLabel": "Artefact : {{id}}",
    "embeddedAlt": "Image intégrée",
    "couldNotLoad": "⚠ Impossible de charger l'image",
    "couldNotLoadAria": "Impossible de charger l'image",
    "couldNotLoadAriaWithAlt": "Impossible de charger l'image — {{alt}}"
  },
  "citation": {
    "loadingData": "Chargement de la citation…",
    "loadTimedOut": "Impossible de charger la citation. Veuillez réessayer.",
    "notAvailable": "Contenu de la citation indisponible.",
    "referencedContent": "Contenu référencé",
    "source": "Source :",
    "referencedImageAlt": "Image référencée",
    "download": "Télécharger",
    "filename": "Nom du fichier :",
    "documentRole": "Rôle du document :",
    "dataType": "Type de données :",
    "contentDescription": "Description du contenu :",
    "metadataUnavailable": "Aucune métadonnée disponible pour cette source.",
    "sourceClassClient": "Base de connaissances institutionnelle du client",
    "sourceClassBennie": "Base de connaissances experte Kyronyx"
  },
  "callouts": {
    "dataGap": "Lacune de données — {{topic}}",
    "dataGapAria": "Lacune de données : {{topic}}",
    "validationAction": "Action de validation — {{topic}}",
    "validationActionAria": "Action de validation : {{topic}}"
  },
  "findings": {
    "noCitationsParseable": "Aucune référence de citation n’a pu être lue dans les preuves de cette observation.",
    "citationLabel": "Citation [{{id}}]",
    "rootCause": "Cause racine",
    "classification": "Classification",
    "crossDimensionRefs": "Références transversales",
    "observation": "Observation",
    "expectedStandard": "Standard attendu",
    "impact": "Impact",
    "recommendation": "Recommandation",
    "missingPlaceholder": "—",
    "themeLabel": "Thème : {{value}}",
    "typeLabel": "Type : {{value}}",
    "primaryLabel": "Principal : {{value}}",
    "attributionLabel": "Attribution : {{value}}",
    "tagLabel": "Étiquette : {{value}}",
    "supportingSymptoms_one": "{{count}} symptôme à l'appui ({{first}})",
    "supportingSymptoms_other": "{{count}} symptômes à l'appui ({{first}} … {{last}})",
    "loadingSymptoms": "Chargement des détails du symptôme…",
    "symptomMeta": "§{{section}} · Type {{severity}}",
    "symptomMetaLegacy": "§{{section}} · Type {{severity}} · {{legacyId}}",
    "symptomMetaCite": "§{{section}} · Type {{severity}}",
    "symptomMetaLegacyCite": "§{{section}} · Type {{severity}} · {{legacyId}}"
  },
  "clearAll": {
    "idleTitle": "Tout supprimer",
    "idleDescription": "Cette action <strong>supprimera définitivement</strong> tous les projets, fichiers importés, rapports générés, journaux d'exécution et tous les modèles enregistrés.",
    "alertHeading": "Cette action est irréversible !",
    "alertBody": "Tout ce qui suit sera supprimé définitivement :",
    "bulletWorkspaces": "Tous les projets, y compris les projets archivés et les projets Reggie",
    "bulletFiles": "Tous les fichiers importés et les images extraites",
    "bulletReports": "Toutes les exécutions, constats et tous les rapports générés",
    "bulletLogs": "Tous les journaux d'appels de modèles",
    "bulletModels": "Tout le registre des modèles : chaque modèle, ses informations, versions, accès et journal des problèmes",
    "keptNote": "Les comptes utilisateurs, les accès de connexion, les invites, les paramètres et les services de connaissances partagés ne sont pas modifiés. Les accès aux modèles sont supprimés avec les modèles.",
    "confirmPrompt": "Saisissez {{phrase}} exactement comme indiqué pour confirmer.",
    "confirmLabel": "Phrase de confirmation",
    "cancel": "Annuler",
    "goButton": "Tout supprimer",
    "purgingTitle": "Suppression de toutes les données...",
    "connecting": "Connexion...",
    "purgingWorkspaces": "Suppression de {{count}} projet(s)...",
    "removingProjects": "En attente de la fin de la suppression de {{count}} projet(s)...",
    "removingData": "Suppression des fichiers, journaux et données du registre...",
    "successTitle": "Tout est supprimé",
    "successBody": "Tous les projets, fichiers, rapports, journaux et modèles ont été supprimés. Redirection...",
    "readBackNow": "Maintenant : {{projects}} projet(s) et {{models}} modèle(s) restent.",
    "readBackNotEmpty": "La suppression a été signalée comme terminée, mais {{projects}} projet(s) et {{models}} modèle(s) sont encore listés. Relancez-la.",
    "readBackFailed": "La suppression est terminée, mais la relecture de l'état actuel a échoué. Rechargez la page pour voir ce qui reste.",
    "deletedItemsHeading": "Éléments supprimés :",
    "goToWorkspaces": "Aller aux espaces de travail",
    "errorTitle": "Erreur",
    "tryAgain": "Réessayer",
    "back": "Retour",
    "unknownError": "Erreur inconnue",
    "failedToClear": "Échec de la suppression : {{status}} {{statusText}}",
    "refusedNotAdmin": "Seul un administrateur peut tout supprimer. Rien n'a été supprimé.",
    "refusedConfirmation": "La phrase de confirmation ne correspond pas. Rien n'a été supprimé.",
    "noResponseStream": "Aucun flux de réponse",
    "partialFailure": "Certaines données n'ont pas pu être entièrement supprimées. Le reste a été supprimé. Relancez la suppression pour terminer.",
    "partialFailureRemaining": "{{count}} projet(s) n'ont pas pu être entièrement supprimés à temps ; le registre des modèles est donc inchangé. Tout le reste a été supprimé. Relancez la suppression pour terminer.",
    "streamEndedEarly": "Le serveur a cessé de répondre avant de confirmer la fin de la suppression ; certaines données peuvent subsister. Relancez la suppression pour vérifier.",
    "connectionLost": "Connexion perdue. Vérification de la fin de la suppression...",
    "connectionLostUnconfirmed": "La connexion a été interrompue et nous n'avons pas pu confirmer la fin de la suppression. Rechargez cette page pour vérifier, puis relancez-la s'il reste des projets ou des modèles.",
    "readBackUnavailable": "L'état actuel n'a pas pu être relu ; on ne sait donc pas ce qui reste. Rechargez cette page et relancez la suppression si nécessaire."
  },
  "serviceTypeGrants": {
    "title": "Accès au déploiement pour {{name}}",
    "body": "Ceci détermine les types de travaux pour lesquels cette personne est habilitée à l’échelle du déploiement. C’est distinct de ce qu’elle peut modifier sur ce modèle.",
    "currentHeading": "Habilitée pour",
    "empty": "Rien n’a été activé directement pour cette personne.",
    "groupNote": "L’accès peut aussi provenir d’un groupe d’annuaire. L’accès par groupe se gère dans votre annuaire et n’apparaît pas ici.",
    "grantHeading": "Activer un autre type de travaux",
    "pickLabel": "Type de travaux",
    "neededHint": "requis ici",
    "grant": "Activer",
    "revoke": "Retirer",
    "close": "Fermer",
    "failedGeneric": "Cette modification n’a pas pu être enregistrée. Rien n’a été modifié."
  },
  "modelInventory": {
    "title": "Inventaire des modèles",
    "description": "Parcourez et gérez votre catalogue de modèles. Sélectionnez une catégorie pour afficher les modèles.",
    "modelsCount_one": "{{count}} modèle",
    "modelsCount_other": "{{count}} modèles",
    "backToInventory": "← Retour à l'inventaire des modèles",
    "modelsInCategory_one": "{{count}} modèle dans cette catégorie",
    "modelsInCategory_other": "{{count}} modèles dans cette catégorie",
    "searchPlaceholder": "Rechercher des modèles…",
    "noModels": "Aucun modèle trouvé.",
    "fallbackTitle": "Modèles",
    "statusActive": "Actif",
    "statusDraft": "Brouillon",
    "statusDeprecated": "Obsolète",
    "versionUpdated": "v{{version}} • Mis à jour le {{date}}",
    "ariaCollapse": "réduire",
    "ariaExpand": "développer",
    "ownerLabel": "Propriétaire : {{value}}",
    "frameworkLabel": "Framework : {{value}}",
    "categoryLabel": "Catégorie : {{value}}",
    "dataLabel": "Données : {{value}}"
  },
  "appAuth": {
    "title": "Accès requis",
    "body": "Cet environnement est protégé par mot de passe. Veuillez saisir le mot de passe d'accès pour continuer.",
    "passwordLabel": "Mot de passe",
    "passwordAria": "Mot de passe d'accès",
    "noPasswordHint": "Si vous n'avez pas le mot de passe, contactez le propriétaire du projet.",
    "submit": "Entrer",
    "submitting": "Vérification…",
    "incorrectPassword": "Mot de passe incorrect.",
    "apiUnreachable": "Impossible de joindre l'API. Vérifiez votre connexion et réessayez.",
    "sessionExpired": "Session expirée ou mot de passe refusé. Veuillez ressaisir.",
    "identityUnavailable": {
      "title": "Bennie est temporairement indisponible",
      "body": "Nous n’avons pas pu vérifier votre session. Veuillez réessayer dans un instant.",
      "retry": "Réessayer"
    },
    "ssoBootstrap": {
      "signingBackIn": "Reconnexion en cours…",
      "stuckTitle": "La connexion prend plus de temps que prévu",
      "stuckBody": "Impossible de restaurer votre session. Veuillez réessayer de vous connecter.",
      "tryAgain": "Réessayer"
    }
  },
  "modelActions": {
    "edit": "Modifier le nom et le type",
    "archive": "Archiver",
    "alreadyArchived": "Archivé",
    "editTitle": "Modifier le nom et le type",
    "editSubtitle": "Vous pouvez modifier le nom et le type du modèle.",
    "nameLabel": "Nom du modèle",
    "typeLabel": "Type de modèle",
    "typeHelp": "Choisissez parmi les types proposés pour ce modèle. La valeur enregistrée reste disponible même si elle n’est plus proposée.",
    "typeMenuUnavailable": "La liste des types est momentanément indisponible : le type ne peut pas être modifié pour l’instant. Le nom reste modifiable.",
    "fixedTitle": "Le chemin de filière et les étiquettes appliquées ne peuvent pas être modifiés.",
    "fixedBody": "Ils ont été définis lors de l’enregistrement.",
    "concurrencyTitle": "Si une autre personne modifie ce modèle avant vous, votre enregistrement est refusé.",
    "concurrencyBody": "Sa version vous sera présentée et il vous sera demandé de la vérifier à nouveau.",
    "cancel": "Annuler",
    "save": "Enregistrer les modifications",
    "saving": "Enregistrement…",
    "archiveTitle": "Archiver ce modèle ?",
    "archiveSubtitle": "L’archivage est irréversible.",
    "archiveOneWayTitle": "Cette action est irréversible.",
    "archiveOneWayBody": "{{name}} passe dans la liste des archives, reste visible de tous et ne peut plus être modifié par personne, administrateurs compris.",
    "archiveBeneathTitle": "Ce qui change en dessous.",
    "archiveBeneathBody": "Aucun nouveau projet ne peut être créé sous ce modèle. Ses projets existants sont signalés comme verrouillés et le banc d’essai passe en lecture seule. Tout ce qui a déjà été produit reste consultable et téléchargeable.",
    "archiveRunningTitle": "Les travaux déjà en cours ne sont pas interrompus.",
    "archiveRunningBody": "L’archivage change le statut de ce modèle. Il n’annule ni une génération de rapport, ni une ingestion de documents, ni un téléversement déjà lancé — tout ce qui est en cours se poursuit et s’achève dans un modèle devenu entre-temps en lecture seule.",
    "confirmLabel": "Saisissez le nom du modèle pour confirmer",
    "archiveGo": "Archiver définitivement",
    "archiving": "Archivage…",
    "errorGeneric": "Cette modification n’a pas pu être enregistrée. Veuillez réessayer dans un instant.",
    "errorTimeout": "Cette modification a pris trop de temps et a été interrompue ; nous ne pouvons pas confirmer si elle a été enregistrée. Rouvrez le modèle pour voir son état, puis réessayez."
  },
  "modelHome": {
    "titleUnknown": "Modèle",
    "loading": "Chargement du modèle",
    "errorNotFound": "Ce modèle est introuvable. Il a peut-être été supprimé, ou le lien est incorrect.",
    "errorLoad": "Ce modèle n'a pas pu être chargé pour le moment. Veuillez réessayer dans un instant.",
    "statusActive": "Actif",
    "statusArchived": "Archivé",
    "fieldModelId": "Identifiant du modèle",
    "fieldModelType": "Type de modèle",
    "fieldScopePath": "Portée",
    "fieldProductCategory": "Catégorie de produit",
    "filterAll": "Tous {{count}}",
    "filterType": "{{type}} {{count}}",
    "projectsFilterLabel": "Filtrer les projets par ligne de défense",
    "pagerProjectsAll_one": "Affichage de {{from}} à {{to}} sur {{count}} projet",
    "pagerProjectsAll_other": "Affichage de {{from}} à {{to}} sur {{count}} projets",
    "projectsEmpty": "Aucun projet n'est encore enregistré sous ce modèle.",
    "projectsLoading": "Chargement des projets",
    "projectsLoadFailed": "Les projets n'ont pas pu être chargés pour le moment. Veuillez réessayer dans un instant.",
    "projectsSearchPlaceholder": "Rechercher des projets",
    "projectsNoMatch": "Aucun projet ne correspond à votre recherche.",
    "projectArchiveTitle": "Archiver ce projet ?",
    "projectArchiveBody": "{{name}} passe dans la liste des archives et ne peut plus être modifié par personne. Il reste visible et peut toujours être ouvert. Rien ne supprime un projet.",
    "projectArchiveConfirmLabel": "Saisissez le nom du projet pour confirmer",
    "projectArchiveFailed": "Ce projet n’a pas pu être archivé. Veuillez réessayer.",
    "projectsArchivedEmpty": "Aucun projet archivé.",
    "lockedByModel": "Verrouillé — modèle archivé",
    "archivedDirectly": "Archivé",
    "parkRunning": "Ajout de vos fichiers exportés au nouveau projet…",
    "parkFailedTitle": "Les fichiers n'ont pas été ajoutés",
    "parkFailed": "Vos fichiers exportés n'ont pas pu être ajoutés au nouveau projet.",
    "tabOverview": "Aperçu",
    "tabProjects": "Projets",
    "tabTestGround": "Banc d'essai",
    "tabToolbox": "Boîte à outils",
    "pagerProjects_one": "Affichage de {{from}} à {{to}} sur {{count}} projet {{type}}",
    "pagerProjects_other": "Affichage de {{from}} à {{to}} sur {{count}} projets {{type}}",
    "sectionEmpty": "Aucun travail {{type}} n’a encore été commencé sur ce modèle.",
    "serviceTypeUnset": "Aucun type de service",
    "tabAccess": "Accès",
    "lockArchivedOn": "Archivé le {{date}}.",
    "lockPill": "Lecture seule",
    "projectsLockTitle": "Ces projets sont verrouillés, et ils restent à votre disposition en lecture.",
    "projectsLockBody": "Vous pouvez ouvrir le rapport, consulter le journal des constats, télécharger l’export et continuer à dialoguer avec le projet.",
    "projectsLockPill": "Lecture seule · dialogue possible",
    "createDeniedForTypeTitle": "Vous ne pouvez pas encore démarrer de travaux de type {{type}} sur ce modèle.",
    "stillWorking": "Toujours en cours. Cela peut prendre un instant.",
    "retry": "Réessayer",
    "recheckFailed": "Le statut de ce modèle n’a pas pu être revérifié à l’instant. Ce qui s’affiche est le dernier enregistrement confirmé par le serveur.",
    "recheckRetry": "Vérifier à nouveau"
  },
  "modelList": {
    "title": "Modèles",
    "subtitle": "{{count}} enregistrés",
    "empty": "Aucun modèle n'est encore enregistré.",
    "loading": "Chargement des modèles",
    "errorLoad": "Les modèles n'ont pas pu être chargés pour le moment. Veuillez réessayer dans un instant.",
    "statusActive": "Actif",
    "statusArchived": "Archivé",
    "searchPlaceholder": "Rechercher des modèles",
    "noMatch": "Aucun modèle ne correspond à votre recherche.",
    "clearSearch": "Effacer la recherche",
    "stillWorking": "Toujours en cours…",
    "retry": "Réessayer",
    "register": "Enregistrer un modèle",
    "registerFirst": "Enregistrer le premier modèle",
    "perPage": "Par page",
    "tabActive": "Actifs {{count}}",
    "tabArchived": "Archivés {{count}}",
    "prev": "Préc.",
    "next": "Suiv."
  },
  "modelAccess": {
    "lockTitle": "L’accès est figé sur un modèle archivé.",
    "lockBody": "L’historique des accès reste visible dans le cadre de la piste d’audit. Rien ne peut y être modifié, y compris la propriété.",
    "lockPill": "Lecture seule",
    "standingHeading": "Votre situation",
    "standingOwner": "Vous êtes le propriétaire de ce modèle.",
    "standingCollaborator": "Vous êtes collaborateur sur ce modèle.",
    "standingNone": "Vous ne détenez aucun accès sur ce modèle.",
    "standingOtherRole": "Vous détenez un rôle d’accès sur ce modèle.",
    "standingAdminOverride": "Dérogation administrateur",
    "subjectAdminBadge": "Administrateur",
    "standingMayWrite": "Vous pouvez modifier ce modèle là où le produit le permet.",
    "standingNothingToPress": "L’accès est géré par le propriétaire.",
    "identityPending": "Vérification en cours du compte avec lequel vous êtes connecté.",
    "ownerHeading": "Propriétaire",
    "ownerHint": "Un modèle a un seul propriétaire, qui décide qui d’autre peut le modifier.",
    "ownerIsYou": "Ce modèle vous appartient.",
    "ownerNoAllowances": "Le propriétaire détient toutes les autorisations par son rôle.",
    "collaboratorsHeading": "Collaborateurs",
    "recordHeading": "Relevé",
    "registeredBy": "Enregistré par {{who}}.",
    "registeredByOn": "Enregistré par {{who}} le {{date}}.",
    "registrarNotOwner": "Il s’agit de la personne qui a enregistré le modèle, pas nécessairement de son propriétaire actuel.",
    "archivedBy": "Archivé par {{who}}.",
    "archivedByOn": "Archivé par {{who}} le {{date}}.",
    "accountIdLabel": "Identifiant de compte",
    "you": "vous",
    "noDefaultGrant": "Tout le monde peut consulter ce modèle et les projets qu’il contient. Seuls le propriétaire et les personnes disposant d’un accès peuvent le modifier.",
    "retry": "Réessayer",
    "loadFailedTitle": "Impossible de charger la liste des accès",
    "ownerMissing": "Ce modèle n’a aucun propriétaire enregistré. Un administrateur peut en désigner un.",
    "ownerSince": "Propriétaire depuis le {{date}} · accordé par {{by}}",
    "collaboratorsHint": "Toute personne de votre organisation peut consulter ce modèle et tout ce qu’il contient, y compris ses espaces de test, et chacun peut utiliser Toolbox. Un collaborateur peut modifier les travaux des types de service cochés pour lui ; la case Collaborateur lui permet de modifier les espaces de test.",
    "collaboratorsNone": "Personne d’autre ne s’est vu accorder quoi que ce soit à modifier sur ce modèle.",
    "colPerson": "Personne",
    "colCanChange": "Peut modifier",
    "colAddedBy": "Ajouté par",
    "transferOpen": "Transférer la propriété…",
    "addOpen": "Ajouter un collaborateur",
    "editOpen": "Modifier",
    "removeOpen": "Retirer",
    "transferTitle": "Transférer la propriété",
    "transferBody": "Le nouveau propriétaire reprend tout ce que vous pouvez faire ici, et vous cessez de pouvoir le faire.",
    "transferNewOwnerLabel": "Nouveau propriétaire",
    "transferKeepsNothing": "Vous ne conserverez rien sur ce modèle. Vous pourrez toujours le consulter, comme tout le monde, mais vous ne pourrez plus le modifier ni décider qui le peut.",
    "transferSubmit": "Transférer la propriété",
    "subjectIdHelper": "Toute personne ayant accès à Bennie, administratrice ou non. Vous pouvez aussi coller un identifiant d’objet d’annuaire.",
    "subjectSearchPlaceholder": "Rechercher par nom ou par e-mail",
    "principalSearchIdle": "Saisissez un nom ou une adresse e-mail pour trouver quelqu’un.",
    "principalSearchTooShort": "Continuez à saisir — une recherche nécessite au moins trois caractères.",
    "principalSearching": "Recherche dans l’annuaire de votre organisation…",
    "principalSearchMatches": "Choisissez la bonne personne dans la liste.",
    "principalSearchTruncated": "Seuls les résultats les plus proches sont affichés — affinez votre recherche si la personne n’y figure pas.",
    "principalSearchNoMatch": "Aucune personne de votre organisation ne correspond. Vérifiez l’orthographe ou collez son identifiant d’objet d’annuaire.",
    "principalSearchUnavailable": "L’annuaire est injoignable : la recherche n’a pas pu être effectuée. Réessayez dans un instant — cela ne signifie pas que personne ne correspond.",
    "principalResolving": "Recherche de cette personne…",
    "principalNotFound": "Aucune personne de votre organisation ne porte cet identifiant. Vérifiez-le avant de continuer — rien n’a été modifié.",
    "principalUnavailable": "L’annuaire est injoignable : cet identifiant n’a pas pu être vérifié. Réessayez dans un instant — rien n’a été modifié.",
    "transferConfirmHint": "Voici la personne qui deviendra propriétaire du modèle. Vérifiez qu’il s’agit bien d’elle — cette action est irréversible.",
    "addConfirmHint": "Voici la personne qui sera ajoutée au modèle.",
    "addTitle": "Ajouter un collaborateur",
    "addSubjectLabel": "Personne",
    "addSubmit": "Ajouter le collaborateur",
    "editTitle": "Modifier les autorisations",
    "editSubmit": "Enregistrer les autorisations",
    "allowancesHeading": "Ce qu’elle peut modifier",
    "allowancesHint": "Cochez les types de travaux que cette personne peut modifier sur ce modèle. Collaborateur lui permet de modifier les espaces de test.",
    "allowancesNoneNotice": "Elles seront ajoutées sans autorisation de modification. Vous pourrez l’accorder plus tard.",
    "allowancesUnrestricted": "Non limité par type de service",
    "allowancesNothingYet": "Rien pour l’instant",
    "entitlementShortfall": "Accordé ici, mais non activé pour {{types}} à l’échelle du déploiement — un administrateur doit l’activer séparément pour que cela prenne effet.",
    "entitlementUnknown": "Nous n’avons pas pu vérifier l’accès de cette personne à l’échelle du déploiement pour le moment.",
    "entitlementManage": "L’activer maintenant",
    "allowancesOther": "Autre",
    "allowanceCollaborator": "Collaborateur",
    "removeTitle": "Retirer cette personne ?",
    "removeBody": "Elle perd tout ce qu’elle pouvait modifier sur ce modèle. Elle pourra toujours le consulter, comme tout le monde.",
    "removeSubmit": "Retirer",
    "cancel": "Annuler",
    "working": "En cours…"
  },
  "modelRegister": {
    "title": "Enregistrer un modèle",
    "subtitle": "Choisissez ce qu’est le modèle, puis nommez-le. Administrateurs uniquement.",
    "step1Title": "Choisir le modèle",
    "step1Hint": "Le même menu que pour démarrer un projet",
    "step2Title": "Continuer",
    "step2Hint": "Ouvre une boîte de dialogue pour terminer l’enregistrement",
    "step3Title": "Nommer le modèle",
    "step3Hint": "Nommez-le et vérifiez le chemin choisi",
    "step4Title": "Page d'accueil du modèle",
    "step4Hint": "Vous y arrivez automatiquement",
    "pickerHeading": "Choisissez ce qu'est ce modèle",
    "pickerHint": "Le même menu que pour démarrer un projet. Descendez jusqu’au dernier niveau.",
    "adminOnly": "L'enregistrement d'un modèle est une action d'administrateur. Vous pouvez parcourir le menu ici, mais seul un administrateur peut finaliser l'enregistrement.",
    "leave": "Quitter",
    "dialogTitle": "Enregistrer un modèle",
    "dialogSubtitle": "Nommez-le et vérifiez le chemin choisi.",
    "sectionIdentity": "1 · Identité",
    "nameLabel": "Nom du modèle",
    "namePlaceholder": "Un nom qui distingue ce modèle",
    "nameHelper": "La seule chose que vous saisissez ici. Choisissez un nom qui distingue ce modèle des autres du même type.",
    "summaryStreamPath": "Chemin du flux",
    "summaryAppliedTo": "Appliqué à",
    "summaryAppliedToNone": "Aucun affinage — l'intégralité du flux.",
    "permanent": "Permanent. Chaque projet, espace de travail du Banc d'essai et tâche de la Boîte à outils sous ce modèle hérite de ce chemin.",
    "sectionCanonicals": "3 · Données canoniques du modèle",
    "canonicalsHint": "Facultatif. Renseignez ce que vous savez maintenant, puis ajoutez ou modifiez ces informations une fois le modèle enregistré.",
    "canonicalsUnavailableAbsent": "Les champs canoniques ne peuvent pas être affichés pour le moment. Enregistrez le modèle, puis ajoutez-les depuis sa page — et signalez à votre administrateur qu’ils sont indisponibles.",
    "canonicalsUnavailableUnreachable": "Les champs canoniques ne peuvent pas être affichés pour le moment. Enregistrez le modèle et ajoutez-les depuis sa page dans quelques minutes.",
    "canonicalsUnavailableGeneric": "Les champs canoniques ne peuvent pas être affichés pour le moment. Enregistrez le modèle et ajoutez-les depuis sa page.",
    "canonicalsLoading": "Chargement des champs canoniques",
    "cancel": "Annuler",
    "submit": "Enregistrer le modèle",
    "submitting": "Enregistrement…",
    "stillWorking": "Toujours en cours. Cela peut prendre un instant.",
    "retry": "Réessayer",
    "errName": "Donnez un nom au modèle avant de l'enregistrer.",
    "errNotPermitted": "L'enregistrement d'un modèle est une action d'administrateur, et ce compte n'en est pas un.",
    "errScope": "Le chemin de menu choisi pour ce modèle n'a pas été accepté. Revenez en arrière et choisissez-le à nouveau.",
    "errUnavailable": "Le menu des services ne répond pas pour le moment, ce modèle ne peut donc pas encore être enregistré. Réessayez sous peu.",
    "errTimeout": "L’enregistrement a pris trop de temps et a été interrompu ; nous n’avons pas pu confirmer si le modèle a été créé. Ouvrez le registre des modèles pour vérifier avant de recommencer.",
    "errGeneric": "Le modèle n'a pas pu être enregistré. Veuillez réessayer.",
    "readBackFailed": "Le modèle a bien été enregistré. Nous n’avons pas pu l’ouvrir à l’instant — réessayez, ou ouvrez-le depuis le registre des modèles. Ne l’enregistrez pas une seconde fois.",
    "readBackRetry": "Réessayer de l’ouvrir"
  },
  "modelTestGround": {
    "hint": "Un espace isolé pour composer et exécuter de la logique de modèle sur vos propres données.",
    "newWorkspace": "Nouvel espace de travail de test",
    "inheritedScope": "Portée héritée",
    "from": "Provenance",
    "onModel": "sur <strong>{{model}}</strong>",
    "playground": "Les pipelines d’ici peuvent être exécutés, exportés dans un projet et cités. Ils ne font pas partie du dossier canonique du modèle.",
    "searchPlaceholder": "Rechercher des espaces de travail de test…",
    "count_one": "{{count}} espace de travail de test",
    "count_other": "{{count}} espaces de travail de test",
    "perPage": "Par page",
    "pagerShowing_one": "Affichage de {{from}} à {{to}} sur {{count}} espace de travail de test",
    "pagerShowing_other": "Affichage de {{from}} à {{to}} sur {{count}} espaces de travail de test",
    "loading": "Chargement des espaces de travail de test",
    "stillWorking": "Toujours en cours…",
    "errorLoad": "Les espaces de travail de test n’ont pas pu être chargés pour le moment. Veuillez réessayer dans un instant.",
    "empty": "Aucun espace de travail de test sur ce modèle pour l’instant.",
    "noMatch": "Aucun espace de travail de test ne correspond à votre recherche.",
    "lockTitle": "Le Banc d’essai reste consultable sur un modèle archivé, et ne s’exécutera pas.",
    "lockBody": "Les anciens espaces de travail de test, leur configuration et chaque résultat d’exécution restent accessibles. La création d’espaces de travail et les modifications sont désactivées.",
    "lockPill": "Lecture seule",
    "writeDenied": "Vous n’avez pas l’autorisation d’apporter des modifications à ce modèle.",
    "createScopeRejected": "Test Ground ne peut pas utiliser le périmètre de ce modèle. Le périmètre est défini sur le modèle.",
    "lastActive": "dernière activité le {{date}}"
  },
  "dashboard": {
    "title": "Tableau de bord",
    "subtitle": "Le portefeuille, une ligne par modèle.",
    "loading": "Chargement de la vue portefeuille",
    "stillWorking": "Toujours en cours…",
    "retry": "Réessayer",
    "errorTitle": "Nous n’avons pas pu charger la vue portefeuille",
    "errorBody": "La demande n’a pas abouti. C’est généralement temporaire.",
    "errorOneMessage": "Si cela persiste, veuillez contacter le support.",
    "emptyTitle": "Rien à présenter pour le moment",
    "emptyBody": "La vue portefeuille se remplit dès que des modèles sont enregistrés et que du travail a été fait sous eux.",
    "emptyOnlyOnSuccess": "Aucun chargement n’a échoué ; le portefeuille est simplement vide.",
    "periodScope": "La période s’applique aux modèles et aux projets affichés, pas à l’achèvement des validations ni aux chiffres des problèmes ouverts.",
    "refreshedScope": "« Actualisé » concerne le temps gagné, recalculé au plus une fois par heure. Les autres chiffres sont relus à chaque chargement.",
    "refreshed": "Actualisé {{when}}",
    "refreshedUnknown": "Heure d’actualisation indisponible",
    "period": {
      "label": "Période",
      "p7d": "7 j",
      "p30d": "30 j",
      "p90d": "90 j",
      "p1y": "1 an",
      "custom": "Personnalisée"
    },
    "countsBy": {
      "label": "Compter par",
      "activity": "Activité",
      "created": "Création"
    },
    "showArchived": "Afficher les archivés",
    "warmingTitle": "Préparation de la vue portefeuille",
    "warmingBody": "Cela prend généralement moins d’une minute, et la page se remplira d’elle-même.",
    "warmingStuckTitle": "Toujours en préparation après une longue attente",
    "warmingStuckBody": "Les chiffres du portefeuille ne sont pas arrivés. Vous pouvez patienter ou les redemander.",
    "staleTitle": "Ces chiffres sont plus anciens qu’ils ne devraient l’être — ils datent de {{when}}",
    "staleBody": "La dernière actualisation n’a pas abouti ; ces données peuvent donc être obsolètes.",
    "refreshNow": "Actualiser maintenant",
    "partialTitle": "Une partie de cette page n’a pas pu être lue",
    "partialBody": "Les chiffres ci-dessous ne couvrent que ce qui a pu être lu. Les décomptes qui seraient trompeurs sont masqués.",
    "kpi": {
      "models": "Modèles enregistrés",
      "modelsSub": "{{projects}} projets en dessous",
      "modelsSubNoProjects": "Nombre de projets indisponible",
      "modelsTooltip": "Modèles correspondant à la période sélectionnée.",
      "approved": "Rapport approuvé",
      "validated": "Validés",
      "validatedSub": "Terminés sur cette période",
      "validatedWithheld": "Non affiché. Ce chiffre compte les modèles d’après leurs projets, et la liste des projets n’a pas pu être lue.",
      "validatedTooltip": "Compte les modèles ayant au moins un projet de validation parvenu à l’état terminal.",
      "openIssues": "Anomalies ouvertes",
      "openIssuesSub": "T1 {{t1}} · T2 {{t2}} · T3 {{t3}} · T4 {{t4}}",
      "openIssuesWithheld": "Non affiché. Seule une partie des données d’anomalies a pu être lue — un décompte partiel afficherait moins d’anomalies ouvertes qu’il n’y en a.",
      "openIssuesTooltip": "Anomalies remontées dans le journal d’un modèle et toujours ouvertes, pour les modèles affichés.",
      "timeSaved": "Temps gagné",
      "timeSavedSub": "≈ {{weeks}} semaines-ETP · {{n}} projets",
      "timeSavedSubWeeksOnly": "≈ {{weeks}} semaines-ETP",
      "timeSavedNoData": "Aucun projet mesuré pour l’instant",
      "timeSavedWithheld": "Non affiché. Les données de mesure n’ont pas pu être lues.",
      "approvedSub": "{{n}} n’ont aucun rapport",
      "approvedWithheld": "Non affiché. Le registre des rapports n’a pas pu être lu.",
      "approvedTooltip": "Compte les modèles dotés d’une version de rapport approuvée, parmi les modèles affichés."
    },
    "coverage": {
      "title": "Couverture",
      "hint": "Une ligne par modèle, une colonne par ligne de défense. Cliquez sur une ligne pour ouvrir le modèle.",
      "search": "Rechercher un nom, un identifiant, un type, un flux ou un déclarant…",
      "stream": "Flux",
      "allStreams": "Tous les flux",
      "colModel": "Modèle",
      "col_development": "Développement",
      "col_validation": "Validation",
      "col_auditing": "Audit",
      "colLastActivity": "Dernière activité",
      "neverOpened": "Jamais ouvert",
      "clearFilters": "Effacer",
      "showing_one": "Affichage de {{from}} à {{to}} sur {{count}} modèle",
      "showing_other": "Affichage de {{from}} à {{to}} sur {{count}} modèles",
      "perPage": "Par page",
      "cellComplete": "Terminé",
      "cellInProgress": "En cours",
      "cellNone": "Aucun",
      "tier": "Niveau de risque",
      "allTiers": "Tous les niveaux de risque",
      "colTier": "Niveau",
      "tierNotSet": "Non défini",
      "colApproval": "Approbation",
      "approvalApproved": "Approuvé",
      "approvalPending": "En attente",
      "approvalNone": "Aucun rapport",
      "cellStale": "Plus ancien",
      "colCoverage": "Développement · Validation · Audit",
      "segment": "{{line}} : {{state}}",
      "noMatchTitle": "Aucun modèle ne correspond à ces filtres",
      "noMatchBody": "Essayez un autre terme de recherche, un autre périmètre ou un autre niveau de risque.",
      "noPeriodTitle": "Aucun modèle sur cette période",
      "noPeriodBody": "Aucun modèle enregistré n’a d’activité sur la période sélectionnée. Choisissez une période plus longue ci-dessus pour les afficher de nouveau.",
      "colCreated": "Création",
      "clearFiltersAction": "Effacer les filtres",
      "showingNone": "Affichage de 0 sur 0 modèle",
      "legendStaleLabel": "Terminé, avant la période",
      "prevPage": "Page précédente",
      "nextPage": "Page suivante"
    },
    "validation": {
      "title": "Ancienneté des validations",
      "hint": "Aucune date d’échéance : rien n’est marqué en retard.",
      "chartWithheld": "L’ancienneté des validations ne peut pas être affichée, car la liste des projets n’a pas pu être lue.",
      "chartOmitted": "Non regroupés par ancienneté : {{n}} modèles dont les validations n’ont pas de date d’achèvement.",
      "barMonths": "{{n}} mois",
      "summaryValidated": "<b>{{n}}</b> validés",
      "summaryNever": "<b>{{n}}</b> jamais",
      "bucket0": "0 à 4 mois",
      "bucket1": "4 à 8 mois",
      "bucket2": "8 à 12 mois",
      "bucket3": "Plus de 12 mois",
      "bucketNever": "Jamais validés",
      "never": "Jamais",
      "footer": "{{n}} modèles · le plus ancien : {{months}} mois",
      "emptyTitle": "Aucune validation enregistrée pour l’instant",
      "emptyBody": "Les modèles dont une validation est terminée apparaissent ici, triés selon le temps écoulé depuis sa fin. Rien n’est marqué en retard.",
      "swipeHint": "Faites glisser pour voir d’autres groupes",
      "scrollMore": "Faites défiler pour {{n}} de plus",
      "allShown": "Tout est affiché"
    },
    "issues": {
      "title": "Anomalies ouvertes par modèle",
      "hint": "Remontées dans le journal d’anomalies de chaque modèle et toujours ouvertes.",
      "stream": "Flux",
      "allStreams": "Tous les flux",
      "search": "Rechercher des modèles",
      "unavailable": "Les chiffres d’anomalies remontées n’ont pas pu être lus.",
      "reading": "Lecture des chiffres d’anomalies remontées…",
      "tier": "T{{n}} · {{name}}",
      "groupModels_one": "{{count}} modèle",
      "groupModels_other": "{{count}} modèles",
      "summary": "{{n}} modèles dans {{streams}} périmètres · {{total}} problèmes ouverts",
      "emptyTitle": "Aucun problème ouvert",
      "emptyBody": "Les constats apparaissent ici une fois remontés dans le journal des problèmes d’un modèle, tant qu’ils restent ouverts.",
      "footnote": "Seules les anomalies remontées sont comptées. Celles qui figurent uniquement dans le journal d’un projet ne le sont pas.",
      "scrollFor": "Faites défiler pour {{count}} de plus",
      "allShown": "Tout est affiché",
      "more": "{{count}} de plus"
    },
    "hygiene": {
      "title": "Hygiène du registre",
      "hint": "Tout le registre actif, pas la période sélectionnée. Révisez une ligne pour voir ses modèles.",
      "noReport": "Modèles sans rapport de développement",
      "noReportSub": "Rien n’a encore été téléversé pour eux.",
      "pending": "Rapports en attente d’approbation",
      "pendingSub": "Téléversé, non approuvé : aucun rapport en vigueur.",
      "canonicals": "Canoniques jamais confirmés",
      "canonicalsSub": "Proposés par l’analyse du rapport, non confirmés depuis.",
      "noProject": "Modèles sans projet",
      "noProjectSub": "Enregistrés et jamais ouverts.",
      "review": "Réviser",
      "colModel": "Modèle",
      "colOwner": "Enregistré par",
      "colRegistered": "Enregistré le",
      "notListed": "Non listés : les modèles sans identifiant associé et les projets sans modèle.",
      "hide": "Masquer"
    },
    "completed": {
      "title": "Rapports terminés",
      "hint": "Projets ayant atteint l’état terminal, comptés le mois où ils ont été marqués comme terminés.",
      "withheld": "Ce graphique est établi à partir des projets rattachés à chaque modèle, et la liste des projets n’a pas pu être lue.",
      "omitted": "Non comptés : {{n}} projets terminés qui ne portent aucune date d’achèvement.",
      "barTooltip": "{{month}} — {{n}} terminés",
      "emptyTitle": "Aucun rapport terminé pour l’instant",
      "emptyBody": "Un projet est compté ici le mois où il est marqué comme terminé, lorsqu’il est verrouillé et que son rapport ne change plus. Les barres mensuelles apparaissent après le premier.",
      "yearHeading": "Année",
      "olderYearsBelow_one": "{{count}} année plus ancienne ci-dessous",
      "olderYearsBelow_other": "{{count}} années plus anciennes ci-dessous",
      "toDate": "à ce jour",
      "allYears": "Toutes les années",
      "completedSince": "terminés depuis {{year}}",
      "bestYear": "Meilleure année : {{year}} · {{n}}",
      "completedIn": "terminés en <b>{{year}}</b>",
      "completedInSoFar": "terminés en <b>{{year}}</b> à ce jour ({{from}}–{{to}})",
      "deltaFirst": "Première année enregistrée",
      "deltaSame": "Identique à {{year}}",
      "deltaSameMonths": "Identique aux mêmes mois de {{year}}",
      "deltaMore": "▲ {{n}} de plus qu’en {{year}}",
      "deltaMoreMonths": "▲ {{n}} de plus qu’aux mêmes mois de {{year}}",
      "deltaFewer": "▼ {{n}} de moins qu’en {{year}}",
      "deltaFewerMonths": "▼ {{n}} de moins qu’aux mêmes mois de {{year}}",
      "deltaPct": "({{pct}} %)",
      "avgPerMonth": "{{avg}} par mois",
      "peakNone": "Aucun rapport terminé",
      "peakMany": "Pic de {{peak}} sur {{n}} mois",
      "peakFew": "Pic : {{months}} · {{peak}}",
      "averageTag": "moyenne",
      "chartNote": "Toutes les années partagent la même échelle : les barres sont comparables d’une année à l’autre. Les mois en pointillés sont en dehors des dates couvertes."
    },
    "review": {
      "search": "Rechercher un modèle, un identifiant ou un déclarant…",
      "registrarUnnamed": "Nom non affiché",
      "registrarNone": "Aucun déclarant enregistré"
    },
    "more": "{{n}} de plus"
  },
  "modelCanonicalFields": {
    "description": "Description",
    "business_unit": "Unité opérationnelle",
    "risk_tier": "Niveau de risque",
    "lifecycle_stage": "Étape du cycle de vie",
    "built_or_bought": "Développé ou acquis",
    "regulatory_framework": "Cadre réglementaire"
  },
  "modelOverview": {
    "mdrTitle": "Rapport de développement du modèle",
    "mdrHint": "La version approuvée est celle que lit chaque exécution de rapport. Tout le monde peut consulter l’historique et télécharger n’importe quelle version ; l’approbation nécessite une autorisation.",
    "mdrLoading": "Chargement de l’historique des rapports",
    "mdrStillWorking": "Toujours en cours…",
    "mdrErrorLoad": "L’historique des rapports n’a pas pu être chargé pour le moment. Veuillez réessayer dans un instant.",
    "retry": "Réessayer",
    "mdrEmpty": "Aucun rapport de développement n’a encore été importé pour ce modèle.",
    "mdrAllWithdrawn": "Toutes les versions du rapport de développement de ce modèle ont été retirées ; le modèle n’a donc aucune documentation actuelle. L’historique figure ci-dessous.",
    "mdrCurrentApproved": "Il s’agit de la version approuvée — celle que le registre considère comme actuelle.",
    "mdrNoneApproved": "Aucune version n’est approuvée : ce modèle n’a donc pas de rapport actuel. La version la plus récente qui n’a pas été retirée est affichée.",
    "mdrUnapprovedInheritance": "Aucune version n'est approuvée. La génération du plan des espaces de travail rattachés à ce modèle utilise la dernière version en attente d'approbation comme référence provisoire non approuvée ; à défaut, elle s'exécute sans rapport.",
    "mdrHistoryHeading": "Historique des versions ({{count}})",
    "mdrHistoryNote": "Toutes les versions restent listées.",
    "parse": "Analyser les canoniques",
    "parsing": "Analyse en cours…",
    "parseCancel": "Arrêter",
    "parseNotReadable": "Une version retirée ne peut pas être lue.",
    "parseFailed": "Le rapport n’a pas pu être lu.",
    "parseStopped": "Lecture arrêtée. Aucune proposition n'a été faite et rien n'a été enregistré.",
    "parseDone": "Lecture terminée. Les propositions sont ouvertes pour révision ci-dessous — rien n'est enregistré tant que vous ne l'enregistrez pas.",
    "mdrColFile": "Fichier",
    "mdrColStatus": "Statut",
    "mdrColUploaded": "Importé le",
    "mdrColActions": "Actions",
    "statusApproved": "Approuvé",
    "statusExempted": "Exempté",
    "exempt": "Exempter",
    "unexempt": "Retirer l’exemption",
    "exemptFailed": "L’exemption n’a pas abouti et nous ne pouvons pas confirmer si elle a été enregistrée. Actualisez pour vérifier avant de réessayer.",
    "statusDraft": "En attente d’approbation",
    "statusSuperseded": "Remplacé",
    "statusWithdrawn": "Retiré",
    "statusUnknown": "Statut indisponible",
    "download": "Télécharger",
    "approve": "Approuver",
    "approving": "Approbation…",
    "approveAlready": "Cette version est déjà approuvée.",
    "approveNotPromotable": "Cette version ne peut pas être approuvée.",
    "approveFailed": "L’approbation ne s’est pas terminée et nous ne pouvons pas confirmer si la version a été approuvée. Actualisez pour vérifier avant de réessayer.",
    "upload": "Importer une nouvelle version",
    "uploading": "Import en cours…",
    "uploadInFlightNote": "Ce fichier ne figure pas dans la liste ci-dessous et n’y apparaîtra pas tant que l’import ne sera pas terminé.",
    "uploadFailed": "L’import ne s’est pas terminé et nous ne pouvons pas confirmer si la nouvelle version a été enregistrée. Actualisez pour vérifier avant de recommencer.",
    "mdrApprovalNote": "Chaque version commence en attente d’approbation. Une seule version peut être approuvée à la fois.",
    "mdrDownloadNote": "Téléchargement uniquement.",
    "canonTitle": "Canoniques du modèle",
    "canonHint": "Ce que le propriétaire déclare vrai à propos de ce modèle. Repris tel quel dans chaque exécution de rapport.",
    "canonErrorLoad": "Les canoniques n’ont pas pu être lus pour le moment. Veuillez réessayer dans un instant.",
    "canonLoading": "Lecture des canoniques",
    "canonStillWorking": "Lecture en cours…",
    "canonEmpty": "Personne n’a encore rien déclaré sur ce modèle.",
    "canonUpdatedBy": "Dernière mise à jour {{date}} par {{actor}}.",
    "canonUpdatedUnknownActor": "Dernière mise à jour {{date}}. L'auteur de la modification n'a pas été enregistré.",
    "canonOwnerLabel": "Responsable du modèle",
    "canonOwnerNone": "Aucun responsable n'est enregistré pour ce modèle.",
    "canonOwnerUnavailable": "Le responsable ne peut pas être affiché pour le moment.",
    "canonUnreviewedBadge": "Extrait — en attente de confirmation",
    "canonEdit": "Modifier",
    "canonEditing": "Modification…",
    "canonEditNotice": "Rien n’est enregistré tant que vous n’enregistrez pas. L’enregistrement consigne les valeurs modifiées et confirme celles que vous avez laissées telles quelles.",
    "canonSave": "Enregistrer les modifications",
    "canonSaving": "Enregistrement…",
    "canonCancel": "Annuler",
    "canonEditFootnote": "L’enregistrement met à jour tous les champs de ce bloc.",
    "canonNoClear": "Une valeur peut être modifiée, mais pas supprimée.",
    "canonNoClearBlock": "Un canonique qui possède une valeur ne peut pas être vidé — il peut seulement être modifié. Remettez une valeur dans {{fields}}, ou cliquez sur Annuler pour la laisser telle quelle.",
    "canonSaveFailedTitle": "Rien n’a été enregistré.",
    "canonSavePartialTitle": "Une partie de ce bloc a été enregistrée : {{saved}} champ(s) enregistré(s), {{failed}} non.",
    "canonSavedFields": "Enregistré : {{fields}}.",
    "canonFieldFailed": "{{field}} — {{reason}}",
    "canonReloadFailed": "Vos modifications ont été envoyées, mais le bloc n’a pas pu être relu ; ce qui est affiché ne correspond donc peut-être pas à ce que le registre contient désormais. Rechargez la page avant de modifier à nouveau.",
    "issuesTitle": "Journal des problèmes",
    "issuesHint": "Toutes les observations de tous les projets actifs de ce modèle. Le statut d’une observation se modifie ici.",
    "issuesEmpty": "Aucun problème n’est enregistré pour ce modèle. Les observations apparaîtront ici une fois que ses projets de validation et d’audit auront été exécutés.",
    "issuesLoading": "Chargement du journal des problèmes",
    "issuesStillWorking": "Chargement du journal des problèmes en cours…",
    "issuesErrorLoad": "Le journal des problèmes n’a pas pu être chargé. Veuillez réessayer.",
    "issuesSaveFailed": "Cette modification n’a pas pu être enregistrée. Veuillez réessayer.",
    "issuesColIssue": "Problème",
    "issuesColService": "Service",
    "issuesColSeverity": "Gravité",
    "issuesColTitle": "Titre",
    "issuesColTheme": "Thème",
    "issuesColProject": "Projet",
    "issuesColAssignee": "Responsable",
    "issuesColStatus": "Statut",
    "issuesColLastAction": "Dernière action",
    "issuesServiceValidation": "Validation",
    "issuesServiceAuditing": "Audit",
    "issuesServiceDevelopment": "Développement",
    "issuesServiceUnknown": "Inconnu",
    "issuesStatusActive": "Actif",
    "issuesStatusRemediating": "En correction",
    "issuesStatusResolved": "Résolu",
    "issuesStatusUnknown": "Inconnu",
    "issuesNoLongerDetected": "Plus détecté",
    "issuesUnassigned": "Non attribué",
    "issuesAssigneeLoading": "Chargement des personnes auxquelles ce modèle peut être attribué.",
    "issuesAssigneeUnavailable": "La liste des personnes auxquelles ce modèle peut être attribué n’a pas pu être lue ; le responsable ne peut donc pas être modifié.",
    "issuesOpenDetail": "Ouvrir « {{title}} »",
    "issuesDetailDescription": "Description",
    "issuesSourceUnknown": "Provenance de la source indisponible",
    "issuesSourceUnversioned": "Source sans version",
    "issuesSourceReport": "Du rapport V{{version}}",
    "issuesSourceReportUnknown": "Numéro de version du rapport non enregistré",
    "issuesSourceRun": "Exécution {{id}}",
    "issuesSourceItem": "Élément {{id}}",
    "issuesOpenInProject": "Ouvrir dans le projet",
    "issuesReasonRequired": "Indiquez le motif du changement de statut.",
    "issuesReasonLabel": "Motif",
    "issuesStatusConfirm": "Enregistrer",
    "issuesCancel": "Annuler",
    "issuesActionEscalated": "Remonté",
    "issuesActionStatusChanged": "Statut passé à {{status}}",
    "issuesActionAssigneeChanged": "Responsable modifié",
    "issuesActionStamp": "{{date}} · {{who}}",
    "startTitle": "Commencer à travailler sur ce modèle",
    "startHint": "Trois actions rapides. Votre accès détermine lesquelles vous pouvez actionner.",
    "lineDevelopment": "Développement",
    "lineValidation": "Validation",
    "lineAuditing": "Audit",
    "lodDevelopment": "1re ligne de défense",
    "lodValidation": "2e ligne de défense",
    "lodAuditing": "3e ligne de défense",
    "lockTitle": "Ce modèle est archivé — tout reste consultable ici, et ses propres informations ne peuvent plus être modifiées.",
    "lockBody": "Les rapports, les valeurs canoniques, le journal des problèmes, les exécutions Test Ground et les tâches Toolbox restent consultables, et les projets qu’il contient restent ouverts à la lecture et au chat.",
    "approveConfirmTitle": "Approuver cette version ?",
    "approveConfirmBody": "L'approbation fait de cette version celle que chaque rapport de ce modèle considère comme la documentation actuelle. Le travail d'autres personnes en dépend. Vous pourrez approuver une autre version plus tard.",
    "approveConfirmGo": "Approuver la version",
    "withdraw": "Retirer",
    "withdrawing": "Retrait…",
    "withdrawAlready": "Déjà retiré. Cette action est irréversible.",
    "withdrawNotWithdrawable": "Cette version ne peut pas être retirée.",
    "withdrawFailed": "Le retrait ne s’est pas terminé et nous ne pouvons pas confirmer si la version a été retirée. Actualisez pour vérifier avant de réessayer.",
    "withdrawConfirmTitle": "Retirer cette version ?",
    "withdrawTerminalBody": "Le retrait met une version hors service. Il ne la supprime pas — le fichier reste dans la liste et reste téléchargeable. Ce qu’elle ne peut plus redevenir, c’est la version actuelle : une version retirée ne peut pas être approuvée et ne peut pas être remise en service. Importez plutôt une nouvelle version.",
    "withdrawLeavesNoCurrentTitle": "Il s’agit du rapport approuvé actuel ; ce modèle n’en aura donc plus.",
    "withdrawLeavesNoCurrentBody": "Retirer la version approuvée laisse ce modèle sans documentation actuelle, et chaque exécution de rapport le lira comme « rien de déclaré ». Approuvez une autre version ou importez-en une nouvelle d’abord si ce n’est pas ce que vous voulez dire.",
    "withdrawReasonLabel": "Motif",
    "withdrawReasonPlaceholder": "p. ex. importé sur le mauvais modèle",
    "withdrawReasonHelper": "Consigné avec votre nom et un horodatage sur la version.",
    "withdrawConfirmGo": "Retirer la version",
    "canonVocabLoading": "Chargement des valeurs autorisées pour ces champs…",
    "canonVocabErrorAbsent": "La liste des valeurs autorisées pour ces champs n’a pas été publiée pour ce déploiement ; les canoniques ne peuvent donc pas être modifiés. Réessayer n’y changera rien — veuillez contacter l’assistance.",
    "canonVocabErrorUnreachable": "La liste des valeurs autorisées pour ces champs n’a pas pu être chargée pour l’instant ; les canoniques ne peuvent donc pas être modifiés. Réessayez dans un instant.",
    "canonVocabErrorGeneric": "La liste des valeurs autorisées pour ces champs n’a pas pu être lue ; les canoniques ne peuvent donc pas être modifiés. Réessayez — si le problème persiste, contactez l’assistance.",
    "canonVocabUnset": "Non déclaré",
    "canonVocabOffValue": "{{value}} — absent de la liste actuelle",
    "canonVocabRetiredValue": "{{label}} — n’est plus proposé",
    "canonVocabOffHelp": "Cette valeur provient du document du modèle et est conservée exactement telle qu’elle y est formulée. Laissez-la ainsi, ou choisissez l’une des valeurs proposées.",
    "canonVocabRetiredHelp": "Cette valeur n’est plus proposée pour les nouvelles saisies. Elle est conservée telle quelle jusqu’à ce que quelqu’un en choisisse une autre.",
    "canonVocabDocumentWording": "Le document du modèle indique : « {{wording}} ». Cette formulation ne figure pas parmi les valeurs proposées ; renseignez ce champ vous-même.",
    "issuesSearch": "Rechercher un problème, un titre, un thème, un projet ou une personne…",
    "issuesFilterNoTheme": "Aucun thème",
    "issuesFilterUnnamed": "Nom non affiché",
    "evidenceTitle": "Pièces justificatives",
    "evidenceLoading": "Chargement des pièces justificatives",
    "evidenceEmpty": "Aucun fichier joint.",
    "evidenceErrorLoad": "Les fichiers joints n’ont pas pu être chargés.",
    "evidenceAdd": "Joindre un fichier",
    "evidenceDownload": "Télécharger",
    "evidenceRemovePending": "Retirer",
    "evidencePendingHint": "Non enregistré",
    "evidenceWithdraw": "Retirer",
    "evidenceUndoWithdraw": "Conserver",
    "evidenceWithdrawStage": "Marquer pour retrait",
    "evidenceWithdrawReasonLabel": "Pourquoi ce retrait ?",
    "evidenceMeta": "Joint par {{who}} le {{when}}",
    "evidenceWithdrawnStamp": "Retiré par {{who}} le {{when}} : {{reason}}"
  },
  "serviceMenu": {
    "unavailableTitle": "La liste des domaines de service n’a pas pu être chargée",
    "unavailableBody": "C’est généralement temporaire. Réessayez dans un instant.",
    "stillWorking": "Toujours en cours…"
  },
  "projectWsModel": {
    "report": {
      "title": "Rapport de développement du modèle",
      "hint": "Chargé depuis le modèle auquel ce projet appartient.",
      "slotLabel": "Rapport enregistré",
      "slotHelp": "Le rapport est tenu à jour sur le modèle : tous les projets qui en dépendent lisent donc le même document.",
      "noModelTitle": "Ce projet n’indique aucun modèle",
      "noModelBody": "Un projet lit son rapport de développement depuis le modèle auquel il appartient. Ce projet n’a pas de modèle enregistré ; aucun rapport ne peut donc être chargé.",
      "noModelGap": "Le modèle est enregistré lorsqu’un projet est créé depuis l’onglet Projets d’un modèle.",
      "errorLoad": "L’historique des rapports n’a pas pu être chargé pour le moment. Cela ne signifie pas que le modèle n’a pas de rapport.",
      "retry": "Réessayer",
      "loading": "Chargement du rapport de développement du modèle",
      "stillWorking": "Toujours en cours…",
      "emptyTitle": "Aucun rapport sur ce modèle pour l’instant",
      "emptyBody": "Aucun rapport de développement n’a encore été importé pour {{model}}. Dès qu’un rapport y est importé et approuvé, il apparaît ici.",
      "emptyTitleAllWithdrawn": "Aucun rapport actuel sur ce modèle",
      "emptyBodyAllWithdrawn": "Toutes les versions du rapport de développement de {{model}} ont été retirées ; il n’y a donc aucun rapport actuel à afficher. Dès qu’un nouveau rapport y est importé et approuvé, il apparaît ici.",
      "goToModelReport": "Ouvrir le rapport du modèle",
      "emptyNoPicker": "Les rapports sont importés sur le modèle, pas sur le projet.",
      "metaNoDate": "date indisponible",
      "metaApproved": "Approuvé · {{date}} · {{model}}",
      "metaLatestUnapproved": "Dernière version · {{status}} · {{date}} · {{model}}",
      "metaPrevious": "Version précédente · {{status}} · {{date}} · {{model}}",
      "versionGroupAria": "Version du rapport à afficher",
      "versionCurrent": "Actuelle",
      "versionPrevious": "Précédente",
      "autoAddedReference": "Ajouté comme référence",
      "download": "Télécharger",
      "unapprovedNotice": "Cette version n’est pas approuvée sur le modèle. Elle est affichée parce qu’il s’agit de ce que le modèle détient actuellement.",
      "reportBelongsToModel": "Ce document appartient au modèle. Il y est modifié, et la modification atteint tous les projets qui en dépendent."
    }
  },
  "table": {
    "showing": "{{shown}} sur {{total}} affichés",
    "clearFilters": "Effacer les filtres",
    "noMatches": "Aucune ligne ne correspond à votre recherche ou à vos filtres."
  },
  "chart": {
    "invalidSpec": "Ce graphique n’a pas pu être affiché, car ses données ne sont pas valides.",
    "loadFailed": "Le graphique n’a pas pu être chargé."
  }
}
